export default "__VITE_ASSET__CjEw65C9__"